import Vue from 'vue'
import OptimoRoute from '@/utilities/plugin/optimoroute'

const OPTIMO_ROUTE_API_KEY = '3cdb0af952bb8fca40c9ba06ec0d5e41tzbLEFlW4g'

export default Vue.use(OptimoRoute, {
  apiKey: OPTIMO_ROUTE_API_KEY,
})
